/**
 * Address model. Encapsulating specific fields required by /answer APIs.
 */
export default class Answer {
    constructor(values) {
        const { id, form_instance_id, answer, attributes, question_id, score } = values;
        this.id = id;
        this.form_instance_id = form_instance_id;
        this.answer = answer;
        this.attributes = attributes;
        this.question_id = question_id;
        this.score = score;
    }
}



// WEBPACK FOOTER //
// ./src/models/answer.jsx